define([
    "jquery",
    "underscore",
    "marionette",
    "forms/account/change_password_form",
    "behaviors/form_errors_behavior",
    "backbone.syphon",
    'bootstrap',
    "holdon"
], function($, _, Marionette, ChangePasswordForm, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        ui: {
            'mt4AccountNo':'#mt4_account_no',
            'submitBtn':'.submit_btn',
            'changePasswordForm': '#change_password_form',
            'confirmForgot': '#confirm_forgot',
            'detailSection': '#detail_section',
            'successReset': '#success_section',
        },

        events:{
            'click @ui.submitBtn':'submit',
            'click @ui.confirmForgot': 'sendResetPasswordLink'
        },

        initialize: function(){
            this.bindUIElements();
        },

        sendResetPasswordLink: function (e) {
            var that = this;

            HoldOn.open({
                theme:"sk-fading-circle"
            });

            $.ajax('/rest_login/password', {
                method: "PUT",
                data: {
                    'already_logged_in': true
                },
                success: function(data){
                    that.ui.detailSection.hide();
                    that.ui.successReset.show();
                    HoldOn.close();
                },
                error: function(model, error){
                    that.ui.detailSection.show();
                    that.ui.successReset.hide();
                    that.triggerMethod('show:errors', error.responseJSON);
                    HoldOn.close();
                }
            })
        },

        submit: function(e) {
            e.preventDefault();

            this.triggerMethod('hide:errors');

            var formData = Backbone.Syphon.serialize(this.ui.changePasswordForm);
            var form = new ChangePasswordForm();
            form.set( formData);

            var errors = form.validate();

            var that = this;
            if(_.size(errors) < 1){
                HoldOn.open({
                    theme:"sk-fading-circle"
                });
                form.validateWithServer({
                    type: 'POST',
                    success: function(model, res){
                        that.ui.changePasswordForm.submit();
                    },
                    error: function(model, error){
                        that.triggerMethod('show:errors', error.responseJSON);
                        HoldOn.close();
                    }
                });
            }else{
                this.triggerMethod('show:errors', errors);
            }
        }
    });
});
